import React from 'react'



export const HighlightRowText = ({ text, searchText }) => {
    if (!searchText || !text.toLowerCase().includes(searchText)) {
      return <td>{text}</td>;
    }
  
    const regex = new RegExp(searchText, 'gi');
    const parts = text.split(regex);
  
    return (
      <td>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && (
              <b className="highlight">{searchText}</b>
            )}
          </React.Fragment>
        ))}
      </td>
    );
  };

